
import ViewResultCardHeaderComponent from "@/components/Shared/ViewResultCard/ViewResultCardHeader/ViewResultCardHeaderComponent";
export default ViewResultCardHeaderComponent;
